import React from "react";
import { CATEGORIES, buildWhatsAppLink } from "../data/products";

const support = [
  { label: "Order via WhatsApp", href: buildWhatsAppLink(), external: true },
  { label: "Why Sandform", href: "#why-us" },
  { label: "Manifesto", href: "#manifesto" },
  { label: "Delivery & Cold-Chain", href: buildWhatsAppLink(), external: true },
];

export const Footer = () => {
  const scrollTo = (href) => {
    if (href.startsWith("#")) document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="site-footer" className="relative bg-[#050505] border-t border-[#161616] pt-20 pb-10">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <div className="font-display text-5xl md:text-6xl tracking-[0.12em] text-[#E6DFD4] leading-none">
              SANDFORM
            </div>
            <p className="mt-5 max-w-sm text-sm text-[#A3A3A3] leading-relaxed">
              Pharmaceutical-grade peptides for athletes and anyone serious about transforming
              their body and life. Delivered discreetly across the UAE.
            </p>
            <a
              data-testid="footer-whatsapp-cta"
              href={buildWhatsAppLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-7 inline-flex items-center gap-2 bg-[#E6DFD4] text-black px-7 py-3.5 text-[11px] tracking-[0.2em] uppercase font-bold hover:bg-white transition-colors duration-300"
            >
              Chat on WhatsApp
            </a>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] tracking-[0.25em] uppercase font-bold text-[#737373] mb-5">
              Products
            </div>
            <ul className="grid grid-cols-2 gap-x-6 gap-y-3">
              {CATEGORIES.map((c) => (
                <li key={c.id}>
                  <button
                    onClick={() => document.querySelector("#products")?.scrollIntoView({ behavior: "smooth" })}
                    className="text-sm text-[#C9C4BB] hover:text-[#E6DFD4] transition-colors duration-300"
                  >
                    {c.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.25em] uppercase font-bold text-[#737373] mb-5">
              Support
            </div>
            <ul className="space-y-3">
              {support.map((s, i) =>
                s.external ? (
                  <li key={i}>
                    <a
                      href={s.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-[#C9C4BB] hover:text-[#E6DFD4] transition-colors duration-300"
                    >
                      {s.label}
                    </a>
                  </li>
                ) : (
                  <li key={i}>
                    <button
                      onClick={() => scrollTo(s.href)}
                      className="text-sm text-[#C9C4BB] hover:text-[#E6DFD4] transition-colors duration-300"
                    >
                      {s.label}
                    </button>
                  </li>
                )
              )}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#161616] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-[#737373]">© SANDFORM 2026. All rights reserved.</p>
          <p className="text-xs tracking-[0.15em] uppercase text-[#5a5a5a]">
            For research purposes only. Not for personal or veterinary use.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
